"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsUngatedForGameraMigration = exports.getIsUngatedForRecalculateImageDimensions = exports.getIsUngatedForBulkImageImport = exports.getIsUngatedForImageUrlImport = exports.getIsUngatedForSuccessAlert = exports.getHasContentAccessScope = exports.getHasCustomFileHostingDomainAccess = exports.getIsUngatedForPreviewThumbnails = exports.getIsUngatedForCdnSharding = exports.getIsUngatedForBypassElasticSearch = exports.getIsUngatedForShutterstockMaintenance = exports.getIsUngatedForBulkFileVisibility = exports.getIsUngatedForCanva = exports.getIsUngatedForVideoExperiments = exports.getUserId = exports.getUser = exports.getUserEmailAddress = exports.getHasFileHostingPaidDomainsScope = exports.getHasFileManagerWriteScope = exports.getHasFileManagerAccessScope = exports.getHasVideoIntegrationScope = exports.getHasCanvaIntegrationScope = void 0;

var _Constants = require("../Constants");

var isUngated = function isUngated(state, gateName) {
  return state.auth.gates.includes(gateName);
};

var hasScope = function hasScope(state, scopeName) {
  return state.auth.user.scopes.includes(scopeName);
};

var getHasCanvaIntegrationScope = function getHasCanvaIntegrationScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.CANVA_INTEGRATION_SCOPE) > -1;
};

exports.getHasCanvaIntegrationScope = getHasCanvaIntegrationScope;

var getHasVideoIntegrationScope = function getHasVideoIntegrationScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.MARKETING_VIDEO_SCOPE) > -1;
};

exports.getHasVideoIntegrationScope = getHasVideoIntegrationScope;

var getHasFileManagerAccessScope = function getHasFileManagerAccessScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.FILE_MANAGER_ACCESS) > -1;
};

exports.getHasFileManagerAccessScope = getHasFileManagerAccessScope;

var getHasFileManagerWriteScope = function getHasFileManagerWriteScope(state) {
  return hasScope(state, _Constants.FILE_MANAGER_WRITE_SCOPE);
};

exports.getHasFileManagerWriteScope = getHasFileManagerWriteScope;

var getHasFileHostingPaidDomainsScope = function getHasFileHostingPaidDomainsScope(state) {
  return hasScope(state, _Constants.FILE_HOSTING_PAID_DOMAINS_SCOPE);
};

exports.getHasFileHostingPaidDomainsScope = getHasFileHostingPaidDomainsScope;

var getUserEmailAddress = function getUserEmailAddress(state) {
  return state.auth.user.email;
};

exports.getUserEmailAddress = getUserEmailAddress;

var getUser = function getUser(state) {
  return state.auth.user;
};

exports.getUser = getUser;

var getUserId = function getUserId(state) {
  return state.auth.user.user_id;
};

exports.getUserId = getUserId;

var getIsUngatedForVideoExperiments = function getIsUngatedForVideoExperiments(state) {
  return isUngated(state, _Constants.VIDEO_EXPERIMENTS_GATE);
};

exports.getIsUngatedForVideoExperiments = getIsUngatedForVideoExperiments;

var getIsUngatedForCanva = function getIsUngatedForCanva(state) {
  return isUngated(state, _Constants.CANVA_GATE);
};

exports.getIsUngatedForCanva = getIsUngatedForCanva;

var getIsUngatedForBulkFileVisibility = function getIsUngatedForBulkFileVisibility(state) {
  return isUngated(state, _Constants.BULK_FILE_VISIBILITY_GATE);
};

exports.getIsUngatedForBulkFileVisibility = getIsUngatedForBulkFileVisibility;

var getIsUngatedForShutterstockMaintenance = function getIsUngatedForShutterstockMaintenance(state) {
  return isUngated(state, _Constants.SHUTTERSTOCK_MAINTENANCE_GATE);
};

exports.getIsUngatedForShutterstockMaintenance = getIsUngatedForShutterstockMaintenance;

var getIsUngatedForBypassElasticSearch = function getIsUngatedForBypassElasticSearch(state) {
  return isUngated(state, _Constants.BYPASS_ELASTIC_SEARCH_GATE);
};

exports.getIsUngatedForBypassElasticSearch = getIsUngatedForBypassElasticSearch;

var getIsUngatedForCdnSharding = function getIsUngatedForCdnSharding(state) {
  return isUngated(state, _Constants.CDN_SHARDING_GATE);
};

exports.getIsUngatedForCdnSharding = getIsUngatedForCdnSharding;

var getIsUngatedForPreviewThumbnails = function getIsUngatedForPreviewThumbnails(state) {
  return isUngated(state, _Constants.PREVIEW_THUMBNAILS_GATE);
};

exports.getIsUngatedForPreviewThumbnails = getIsUngatedForPreviewThumbnails;

var getHasCustomFileHostingDomainAccess = function getHasCustomFileHostingDomainAccess(state) {
  return isUngated(state, _Constants.FREE_FILE_HOSTING_DOMAIN_GATE) ? getHasFileHostingPaidDomainsScope(state) : true;
};

exports.getHasCustomFileHostingDomainAccess = getHasCustomFileHostingDomainAccess;

var getHasContentAccessScope = function getHasContentAccessScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.CONTENT_ACCESS_SCOPE) > -1;
};

exports.getHasContentAccessScope = getHasContentAccessScope;

var getIsUngatedForSuccessAlert = function getIsUngatedForSuccessAlert(state) {
  return isUngated(state, _Constants.SUCCESS_ALERT_GATE);
};

exports.getIsUngatedForSuccessAlert = getIsUngatedForSuccessAlert;

var getIsUngatedForImageUrlImport = function getIsUngatedForImageUrlImport(state) {
  return isUngated(state, _Constants.IMAGE_URL_IMPORT_GATE);
};

exports.getIsUngatedForImageUrlImport = getIsUngatedForImageUrlImport;

var getIsUngatedForBulkImageImport = function getIsUngatedForBulkImageImport(state) {
  return isUngated(state, _Constants.BULK_IMAGE_IMPORT_GATE);
};

exports.getIsUngatedForBulkImageImport = getIsUngatedForBulkImageImport;

var getIsUngatedForRecalculateImageDimensions = function getIsUngatedForRecalculateImageDimensions(state) {
  return isUngated(state, _Constants.RECALCULATE_IMAGE_DIMENSIONS_GATE);
};

exports.getIsUngatedForRecalculateImageDimensions = getIsUngatedForRecalculateImageDimensions;

var getIsUngatedForGameraMigration = function getIsUngatedForGameraMigration(state) {
  return isUngated(state, _Constants.GAMERA_MIGRATION_GATE);
};

exports.getIsUngatedForGameraMigration = getIsUngatedForGameraMigration;